import Axios from 'axios'
import store from '../store'

const manager = {
  getClientId () {
    return store.getters['Client/clientId']
  },
  getManagers () {
    return Axios.get('api/internal/clients/' + this.getClientId() + '/manager')
  },
  saveManagers (managers) {
    return Axios.put('api/internal/clients/' + this.getClientId() + '/manager', managers)
  }
}

export default manager
